import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AppState, ChatDataActions, selectDataOrigin, selectTempFiles } from '@iese-chatbot/chat-data-access';
import { ChatUtils, DataOrigin, Shortcut, ShortcutType } from '@iese-chatbot/common-utils';
import { Store } from '@ngrx/store';
import { DialogModule } from 'primeng/dialog';
import { takeUntil } from 'rxjs';
import { AbstractKeywordsComponent } from '../../forms/shortcuts/abstract-keywords/abstract-keywords.component';
import { AcademicContentComponent } from '../../forms/shortcuts/academic-content/academic-content.component';
import { SyllabusComponent } from '../../forms/shortcuts/syllabus/syllabus.component';
import { TeachingNoteComponent } from '../../forms/shortcuts/teaching-note/teaching-note.component';
import { TranslationsComponent } from '../../forms/shortcuts/translations/translations.component';

@Component({
  selector: 'icbc-shortcut-form',
  standalone: true,
  imports: [
    CommonModule,
    DialogModule,
    TeachingNoteComponent,
    AcademicContentComponent,
    SyllabusComponent,
    AbstractKeywordsComponent,
    TranslationsComponent,
  ],
  templateUrl: './shortcut-form.component.html',
})
export class ShortcutFormComponent implements OnInit, OnDestroy {
  @Input() public shortcut: Shortcut | null = null;
  @Output() public closeForm: EventEmitter<void> = new EventEmitter<void>();
  protected visible = true;
  protected dataOrigin: DataOrigin = DataOrigin.REPOSITORY;
  protected readonly ShortcutType = ShortcutType;

  private _files: File[] = [];
  private _unsubscribe$ = new EventEmitter<void>();

  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit(): void {
    this.store
      .select(selectTempFiles)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((files) => {
        this._files = files;
      });
    this.store
      .select(selectDataOrigin)
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((dataOrigin) => {
        this.dataOrigin = dataOrigin;
      });
  }

  public ngOnDestroy(): void {
    this._unsubscribe$.next();
    this._unsubscribe$.complete();
  }

  protected sendData(data: string | null) {
    if (data && this.shortcut) {
      const payload = ChatUtils.createAddChatPayload(data, this.dataOrigin, this._files, this.shortcut);
      this.store.dispatch(ChatDataActions.addChat(payload));
      this.router.navigate(['', 'chat', payload.chat.id]).then();
      this.store.dispatch(ChatDataActions.clearFiles());
    }
    this.visible = false;
    this.closeForm.next();
    this.closeForm.complete();
  }

  protected close() {
    this.store.dispatch(ChatDataActions.clearFiles());
    this.closeForm.next();
    this.closeForm.complete();
  }
}
